"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var ArrowUp_1 = tslib_1.__importDefault(require("@eduzz/houston-icons/ArrowUp"));
var houston_styles_1 = require("@eduzz/houston-styles");
var SortLabel = function (_a) {
    var id = _a.id, children = _a.children, sortable = _a.sortable, active = _a.active, direction = _a.direction, disabled = _a.disabled, onClick = _a.onClick;
    if (!sortable) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
    }
    return ((0, jsx_runtime_1.jsxs)("div", tslib_1.__assign({ id: id, className: (0, houston_styles_1.cx)('hts-table-column-sort', { 'hts-table-column-sort-rev': direction === 'desc' }), onClick: disabled ? undefined : onClick }, { children: [children, active && (0, jsx_runtime_1.jsx)(ArrowUp_1.default, { className: 'hts-table-column-sort-icon' })] })));
};
/**
 * @deprecated Use Table from Antd
 * https://ant.design/components/table/
 */
exports.default = SortLabel;
